export default __webpack_public_path__ + "static/media/VMS_Cloud_logo.c1de373c.png";